import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import IndexDefault from "./Index";
import IndexWhitespace from "../pageswhitespace/IndexWhitespace";
import IndexNonCaptive from "./Index";
import FullScreenLoader from "@/components/FullScreenLoader";

/**
 * IndexRouting - Routes /index to correct component based on BAP parameter
 *
 * For Non-Captive (PhonePe): Uses IndexNonCaptive for pre-login pages (Landing → Consent → Login → Lender Selection)
 * For other BAPs: Uses IndexWhitespace or default Index
 */
const IndexRouting = () => {
  const { enc_id } = useParams<{ enc_id: string }>();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [routeType, setRouteType] = useState<'default' | 'whitespace' | 'phonepe' | null>(null);

  useEffect(() => {
    // Get BAP name from query params
    const bapParam = searchParams.get('bap') || searchParams.get('bap_name') || searchParams.get('bap_id');
    
    // Check for PhonePe - use IndexNonCaptive for pre-login flow
    if (bapParam && bapParam.toLowerCase() === 'phonepe') {
      setRouteType('phonepe');
      return;
    }

    // Determine whether to use whitespace theme based on multiple indicators
    const sessionBapId = sessionStorage.getItem('whitespace_bap_id');
    const hasBapQueryParam = bapParam != null;

    // Explicit whitespace path or parameter
    const isExplicitWhitespace = enc_id === 'WHITESPACE' || location.pathname.includes('/whitespace/');

    // Set to whitespace if any whitespace indicator is present
    if (isExplicitWhitespace || hasBapQueryParam || sessionBapId) {
      setRouteType('whitespace');
    } else {
      setRouteType('default');
    }
  }, [enc_id, searchParams, location.pathname]);

  if (routeType === null) {
    return <FullScreenLoader loading={true} />;
  }

  if (routeType === 'phonepe') {
    return <IndexNonCaptive />;
  }

  if (routeType === 'whitespace') {
    return <IndexWhitespace />;
  }

  return <IndexDefault />;
};

export default IndexRouting;
